import React, { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

interface RouteGuardProps {
  children: ReactNode;
}

export const RouteGuard: React.FC<RouteGuardProps> = ({ children }) => {
  const token = localStorage.getItem('token');
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  if (token && user.role_id == 9) {
    return <>{children}</>;
  }
  return <Navigate to='/backoffice' replace />;
};
